$(function () {
    window.initFlatpickr?.();

    $('.js-select').select2({
        allowClear: true,
        escapeMarkup: function(markup) {
            return markup;
        }
    });

    $('[data-fancybox]').fancybox({
        touch: false,
        dragging: false
    });

    $('[data-fancybox-food]').fancybox({
        touch: false,
        dragging: false,
        afterShow : function() {
            $('#food-restaurant-id:not(.not-empty)').select2('open');
        }
    });

    window.trimInputs?.();

});

$(window).on("load", function () {
});

function scrolling() {
}

function resizing() {
}

$(document).on('scroll', scrolling);
$(window).resize(resizing);
